import * as types from './mutation-types'

// ChangeCurrentMenu 时menu尚未加载完毕保存临时route
// let tempChangeCurrentMenuRoute = null

const changeLoadingView = ({commit}, val) => {
    commit(types.CHANGELOADING, val)
}

const changeLoadingText = ({commit}, val) => {
    commit(types.CHANGELOADINGTEXT, val)
}

const changeVLoadingView = ({commit}, val) => {
    commit(types.CHANGEVLOADING, val)
}
const changeVLoadingText = ({commit}, val) => {
    commit(types.CHANGEVLOADINGTEXT, val)
}

const setToken = ({commit}, val) => {
    commit(types.SETTOKEN, val)
}

const setUserInfo = ({commit}, val) => {
    commit(types.SETUSERINFO, val)
}

export {
    changeLoadingView,
    changeLoadingText,
    changeVLoadingView,
    changeVLoadingText,
    setToken,
    setUserInfo,
}
